import { render, staticRenderFns } from "./DailyTraffic.vue?vue&type=template&id=f7b1c5b6"
import script from "./DailyTraffic.vue?vue&type=script&lang=js"
export * from "./DailyTraffic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports